import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {User} from '../../users/models/User.model';
import {SessionManagerService} from '../../../core/services/session-manager.service';
import {environment} from 'src/environments/environment';
import {JwtToken} from "../../../shared/models/JwtToken";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private API_URL = environment.apiUrl + '/auth';

  constructor(
    private httpClient: HttpClient,
    private sessionManagerService: SessionManagerService,
    private router: Router
  ) {
  }

  signInUser(user: User) {
    return this.httpClient.post<JwtToken>(this.API_URL + '/signin', user);
  }

  register(request: RegisterRequest) {
    return this.httpClient.post<RegisterResponse>(this.API_URL + '/register', request);
  }

  updateToken(restaurantId: number | null) {
    if (restaurantId) {
      return this.httpClient.get<JwtToken>(this.API_URL + '/refresh', {
        params: {restaurantId: restaurantId},
      });
    } else {
      return this.httpClient.get<JwtToken>(this.API_URL + '/refresh');
    }
  }

  generateResetPasswordToken(email: string) {
    return this.httpClient.post(this.API_URL + '/reset-password/generate', {email});
  }

  resetPassword(token: string, password: string) {
    return this.httpClient.post(this.API_URL + '/reset-password', {token, password})
  }

  checkEmail(email: string) {
    return this.httpClient.get<{ available: boolean }>(this.API_URL + '/check-email', {
      params: { email }
    });
  }

  acceptInvitation(token: string) {
    return this.httpClient.post<AcceptInvitationResponse>(this.API_URL + '/accept-invitation', {token});
  }

  autoNavigateIfLoggedIn() {
    if (this.sessionManagerService.loggedIn()) {
      this.router.navigate(['/dashboard']);
    }
  }
}

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone?: string;
}

export interface RegisterResponse {
  user: User;
  jwt: JwtToken;
}

export interface AcceptInvitationResponse {
  newUser: boolean;
}
